"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApsConfiguration = exports.AdskEnvironment = void 0;
var AdskEnvironment;
(function (AdskEnvironment) {
    AdskEnvironment[AdskEnvironment["Dev"] = 0] = "Dev";
    AdskEnvironment[AdskEnvironment["Stg"] = 1] = "Stg";
    AdskEnvironment[AdskEnvironment["Prd"] = 2] = "Prd";
    AdskEnvironment[AdskEnvironment["Local"] = 3] = "Local";
})(AdskEnvironment || (exports.AdskEnvironment = AdskEnvironment = {}));
class ApsConfiguration {
    constructor(apsConfigurationParams) {
        this.baseAddress = new URL('https://developer.api.autodesk.com');
        this.baseOptions = apsConfigurationParams.baseOptions;
        this.formDataCtor = apsConfigurationParams.formDataCtor;
        switch (apsConfigurationParams.environment) {
            case AdskEnvironment.Local: {
                this.baseAddress = new URL('http://localhost:1234');
                break;
            }
            case AdskEnvironment.Dev: {
                this.baseAddress = new URL('https://developer-dev.api.autodesk.com');
                break;
            }
            case AdskEnvironment.Stg: {
                this.baseAddress = new URL('https://developer-stg.api.autodesk.com');
                break;
            }
            default: {
                this.baseAddress = new URL('https://developer.api.autodesk.com');
                break;
            }
        }
    }
}
exports.ApsConfiguration = ApsConfiguration;
